import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteCrecaAccountsService } from "@/features/accounts/creca/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useDeleteCrecaAccountStates } from "@/features/accounts/creca/hooks/use-delete-accounts-states";
import { useContext } from "react";


export const useDeleteCrecaAccount = () => {
  const {
    crecaAccountId,
    institutionType,
    setCrecaAccountId,
    setInstitutionType,
    isShowErrorDialog,
    setIsShowErrorDialog,
  } = useDeleteCrecaAccountStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deleteCrecaAccountsService = new DeleteCrecaAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // クレカ削除
  const deleteCrecaAccounts = async (
    accountGroupId: string,
    crecaAccountId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteCrecaAccountsService.deleteCrecaAccounts({
        account_group_id: accountGroupId,
        creca_account_id: crecaAccountId,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("deleteCrecaAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    crecaAccountId,
    institutionType,
    setCrecaAccountId,
    setInstitutionType,
    isShowErrorDialog,
    setIsShowErrorDialog,
    deleteCrecaAccounts: errorHandledAsync(deleteCrecaAccounts, setError),
  };
};
